import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import EdgeCamera from './components/EdgeCamera';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<EdgeCamera />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;